import * as actionTypes from "./actionTypes";
import { deleteInvoice } from "../api/deleteFormData";
import { onChangeCurrCodeOrDirectShipDate } from "../api/getEntrySummaryData";
import { calculateAllInvoiceMerchandise } from "./DescriptionOfMerchandiseActions";

export function handleHTSOverRide(lineItemIndex, dutyItemIndex) {}

export function updateInvoiceItemField(index, field, payload) {
  return {
    type: actionTypes.UPDATE_INVOICE_ITEM_FIELD,
    payload,
    index,
    field,
  };
}
// export function saveHeaderPartyAddress(index, field, payload){
//   return {
//     type: actionTypes.SAVE_HEADER_PARTY_ADDRESS,
//     payload,
//     index,
//     field
//   }
// }
// export function updateHeaderPartie(index, field, payload) {
//   return {
//     type: actionTypes.UPDATE_INVOICE_HEADERPARTY_ITEM,
//     payload,
//     index,
//     field
//   }
// }

export function addInvoiceItem(newInvoiceItem) {
  return {
    type: actionTypes.ADD_INVOICE_ITEM,
    newInvoiceItem,
  };
}
export function InvoiceWarningOnAddition(errorsList) {
  return {
    type: actionTypes.INVOICE_WARNING_ON_ADDITION,
    errorsList,
  };
}

export function removeInvoiceItem(invoiceId, invoiceIndex, updateStatus) {
  return (dispatch, getState) => {
    deleteInvoice(invoiceId, invoiceIndex, updateStatus)
      .then((response) => {
        updateStatus();
        dispatch({
          type: "REMOVE_INVOICE_ITEM",
          index: invoiceIndex,
          invoiceId,
        });
        setTimeout(() => {
          dispatch({
            type: "UPDATE_AND_SAVE_TOTALS",
          });
        }, 1000);
      })
      .catch((error) => {
        console.error(`Error from axios on FIELD set: `, error);
      });
  };
}

// export function updateHeaderPartieAddress(actor, field, payload, index) {
//   return {
//     type: actionTypes.UPDATE_INVOICE_ACTOR_ADDRESS,
//     index,
//     payload,
//     actor,
//     field
//   }
// }

// Save
export function saveInvoiceField(field) {
  return {
    type: actionTypes.SAVE_INVOICE_FIELD,
    field,
  };
}

// export function saveVendorName(invoiceIndex, vendorId, field) {
//   return {
//     type: actionTypes.SAVE_VENDOR_NAME,
//     index: invoiceIndex,
//     vendorId: vendorId,
//     field
//   }
// }

// export function saveImporterNo(){
//   return {
//     type: actionTypes.SAVE_VENDOR_NUMBER
//   }

// }
// export function saveVendorAddress(invoiceIndex) {
//   return {
//     type: actionTypes.SAVE_VENDOR_ADDRESS,
//     index: invoiceIndex
//   }
// }

export function saveDescriptionOfInvoiceItem(invoiceIndex, field, value, formType) {
  // console.log("step4",field,value)
  return {
    type: actionTypes.SAVE_INVOICE_ITEM,
    index: invoiceIndex,
    field,
    value,
    formType
  };
}
export function addMerchandiseIdToInvoice(merchandiseId, invoiceId) {
  return {
    type: actionTypes.ADD_MERCH_ID_TO_INVOICE,
    merchandiseId,
    invoiceId,
  };
}

export function removeMerchandiseFromInvoice(merchandiseId, invoiceId) {
  return {
    type: actionTypes.REMOVE_MERCH_ID_FROM_INVOICE,
    merchandiseId,
    invoiceId,
  };
}
function getCountry(onCurrCodeOrDirectShipDateChange, currencyCode) {
  for (let i = 0; i < onCurrCodeOrDirectShipDateChange.length; i++) {
    if (onCurrCodeOrDirectShipDateChange[i].value === currencyCode) {
      return onCurrCodeOrDirectShipDateChange[i].text;
    }
  }
  return "";
}
export function onCurrCodeOrDirectShipDateChange(
  invoiceId,
  directShipmentDate,
  currencyCode,
  onCurrCodeOrDirectShipDateChange
) {
  return (dispatch, getState) => {
    // let currCode = currencyCodeMap();
    let _currency = currencyCode
      ? getCountry(onCurrCodeOrDirectShipDateChange, currencyCode)
      : null;
    let _date = directShipmentDate || null;
    if (_date && _currency) {
      onChangeCurrCodeOrDirectShipDate(_date, _currency).then((res) => {
        // console.log("step1",res.data.eventMessage)
        dispatch({
          type: actionTypes.ON_CURRENCY_CODE_OR_DIRECT_SHIPMENT_DATE_CHANGED,
          response: res.data.eventMessage,
          invoiceId,
        });
        setTimeout(() => {
          dispatch(calculateAllInvoiceMerchandise(invoiceId));
          setTimeout(() => {
            dispatch({
              type: "UPDATE_AND_SAVE_TOTALS",
            });
          }, 1000);
        }, 100);
      });
    }
  };
}

export function onExchangeRateChanged(invoiceId, value) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ON_EXCHANGE_RATE_ON_INVOICE_CHANGED,
      rateOfExchange: value,
      invoiceId,
    });
    setTimeout(() => {
      dispatch(calculateAllInvoiceMerchandise(invoiceId));
      setTimeout(() => {
        dispatch({
          type: "UPDATE_AND_SAVE_TOTALS",
        });
      }, 1000);
    }, 100);
  };
}

export function updateDOIHeaderPartie(
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  field,
  payload
) {
  return {
    type: actionTypes.UPDATE_DOI_HEADERPARTY_ITEM,
    formType,
    invoiceId,
    merchandiseId,
    vendorId,
    field,
    payload,
  };
}

export function updateDOIHeaderPartieAddress(
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  field,
  payload
) {
  return {
    type: actionTypes.UPDATE_DOI_ACTOR_ADDRESS,
    formType,
    invoiceId,
    merchandiseId,
    vendorId,
    field,
    payload,
  };
}

export function saveDOIHeaderPartyName(
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  field,
  payload
) {
  return {
    type: actionTypes.SAVE_DOI_HEADER_PARTY_NAME,
    formType,
    invoiceId,
    merchandiseId,
    vendorId,
    field,
    payload,
  };
}

export function saveDOIHeaderPartyAddress(
  formType,
  invoiceId,
  merchandiseId,
  vendorId,
  field,
  payload,
) {
  return {
    type: actionTypes.SAVE_DOI_HEADER_PARTY_ADDRESS,
    formType,
    invoiceId,
    merchandiseId,
    vendorId,
    field,
    payload,
  };
}

export function updateWaiverStatus(
  invoiceId,
  field,
  payload,
) {
  return {
    type: actionTypes.UPDATE_WAIVER_STATUS,
    invoiceId,
    field,
    payload,
  };
}

export function saveWaiverStatus(
  invoiceId,
  manufacturerId,
  field,
  payload,
) {
  return {
    type: actionTypes.SAVE_WAIVER_STATUS,
    invoiceId,
    manufacturerId,
    field,
    payload,
  };
}



export function updateCFIAPGAField(
  invoiceId,
  field,
  payload
){
  return {
    type:actionTypes.UPDATE_CFIAPGA_FIELDS,
    invoiceId,
    field,
    payload
  }
}

